export default __webpack_public_path__ + "static/media/dotline.f72368a1.png";